
























































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class CountryRegion extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * マニュアルダウンロードに同意
   */
  private agree() {
    this.$emit('agree')
  }

  /**
   * モーダルを非表示にする
   */
  private cancel() {
    this.$emit('cancel')
  }
}
